import { Component, Input, SimpleChange, SimpleChanges, TemplateRef } from '@angular/core';
import { BaseComponent } from '../_common/dx-base-component';
import { accordionPane } from '../_interfaces/icontrols-common/accordionPane.interface';

@Component({
    selector: 'dx-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    standalone: false
})
export class AccordionComponent extends BaseComponent {
    @Input() multiple: boolean = false;
    @Input() activeIndex: number | number[] = 0;
    @Input() accordionPanes!: accordionPane[];
    @Input() contentTemplate!: TemplateRef<any>;
    @Input() headerTemplate!:  TemplateRef<any>;
    override ngOnInit() {
        super.ngOnInit();

    }    
}
